import * as Yup from "yup";

const insuranceValidationSchema = Yup.object().shape({
  insuranceStartDate: Yup.date().required(),
  insuranceEndDate: Yup.date().required(),
  certificateNumber: Yup.string().required(),
});

export default insuranceValidationSchema;
